import React,{useState,useRef} from 'react';
import Carousel, { consts } from 'react-elastic-carousel'
import Item from './Item';
import CourseItem from './CourseItem';
import '../css/B2C.css';
import B2Cservice from './B2Cservice';

function B2C() {
    let b2c_services=["International projects","Core courses","Tution classes"]
    let b2c_services_res=[1,2,3]
    function myArrow({ type, onClick, isEdge }) {
        const pointer = type === consts.PREV ? 'back' : 'forward'
        const btn = <ion-icon name={`arrow-${pointer}-outline`} style={{ color: "#dddddd", fontSize: "35px" }} ></ion-icon>
        return (

            <button style={{ border: "none", background: "none",position:"absolute",top:"5%",zIndex:"2" }} className={type===consts.PREV?"start-0":"end-0"} onClick={onClick} disabled={isEdge}>
                {btn}
            </button>
        )
    }
 
    function renderPagination({ pages, activePage, onClick }) {
        
        return (
            <div className="d-flex justify-content-evenly align-items-end b2c-nav">
              {pages.map((page,index) => {
                const isActivePage = activePage === page
                return (
                  <div
                    key={page}
                    onClick={() => 
                    onClick(page)
                    } style={{color:`${isActivePage?"whitesmoke":"grey"}`,cursor:"pointer",transition:".5s",borderBottom:`${isActivePage?"4px solid #dddddd":""}`}}
                    active={isActivePage} className=' b2c-service px-4'>{window.innerWidth>=1000? b2c_services[index]:b2c_services_res[index]} </div>
                )
              })}
            </div>
          )
      }

    //   const carouselRef = useRef(null);
    //   const onNextStart = (currentItem, nextItem) => {
    //     if (currentItem.index === nextItem.index) {
    //       // we hit the last item, go to first item
    //       carouselRef.current.goTo(0);
    //     }
    //   };
    //   const onPrevStart = (currentItem, nextItem) => {
    //     if (currentItem.index === nextItem.index) {
    //       // we hit the first item, go to last item
    //       carouselRef.current.goTo(3);
    //     }
    //   };
    return (
        <>
        <section className='b2c-container'>
<div className="-4">
            <h2 className='text-center white-text letter-dis-1 mb-4 letter-dis-3'>B2C services we provide</h2>
</div>

            <Carousel
                itemsToShow={1}
                itemsToScroll={1}
                easing="cubic-bezier(0,1.2,.76,.81)"
                tiltEasing="cubic-bezier(0.110, 1, 1.000, 0.210)"
                transitionMs={800}
                className={`${window.innerWidth>750&& "container"} position-relative`}
                renderArrow={myArrow}
                renderPagination={renderPagination}
                >
                {b2c_services.map((item)=>{
                    return <Item key={item}>
                    <B2Cservice title={item} />
                </Item>
                })}
            </Carousel>
            </section>

        </>
    )
}

export default B2C;
